import React from 'react';
import { Link } from 'gatsby';
import { Home } from '../../../../../static/icons/home';
import InfoPopup from '../infoPopup/InfoPopup';

export const Breadcrumbs = ({
  levels,
  infoText,
  infoOpeningDirection = 'left',
}) => (
  <div className="flex w-full flex-col flex-1 gap-10 px-8 lg:mx-auto my-5 md:max-w-7xl">
    <div className="flex self-start md:self-center w-full py-4 justify-between">
      <nav className="text-sm" aria-label="Breadcrumb">
        <ol className="flex flex-wrap">
          {levels.map((level, index) => (
            <li key={level.title} className="flex items-center">
              {index === 0 && <Home />}
              {index < levels.length - 1 ? (
                <Link
                  to={level.href}
                  className="text-customGray-900 global-hover pl-1"
                >
                  {level.title}
                </Link>
              ) : (
                <span className="px-1 text-customGray-500">{level.title}</span>
              )}
              {index < levels.length - 1 && (
                <span className="px-1 text-customGray-500">/</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
      {infoText && (
        <InfoPopup
          description={infoText}
          displayDirection={infoOpeningDirection}
        />
      )}
    </div>
  </div>
);
